import { render, staticRenderFns } from "./CbsObjectsTable.vue?vue&type=template&id=7949f340&scoped=true"
import script from "./CbsObjectsTable.vue?vue&type=script&lang=js"
export * from "./CbsObjectsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7949f340",
  null
  
)

export default component.exports